import { webapi } from '@spot-fe/utils';
import { Side } from './market';
export { Side } from './market';

export interface CancelOrderParams {
  clearAll: boolean;
  orderIdList: number[];
}

export const cancelOrder = (params: CancelOrderParams) => {
  return webapi.post<void>(`/spot/api/marketTrading/v1/order/cancel`, params);
};

export interface CreateTakerOrderParams {
  orderId: number;
  feeAmount: string;
  quantity?: number;
}

export const createTakerOrder = (params: CreateTakerOrderParams) => {
  return webapi.post<void>(`/spot/api/marketTrading/v1/order/market`, params);
};

export enum EnumOrderType {
  "FULL" = 0,
  "PARTIAL" = 1,
}

// export enum Side {
//   Sell = 1,
//   Buy = 2,
// }

export interface CreateMakerOrderParams {
  tokenName: string;
  side: Side; // 1 sell, 2 buy
  price: string;
  quantity: string;
  orderAmount: string;
  feeAmount: string;
  paymentAmount: string;
  pledgeAmount: string;
  partType: number;
}

export const createMakerOrder = (params: CreateMakerOrderParams) => {
  return webapi.post<void>(`/spot/api/marketTrading/v1/order/pending`, params);
};

export const getPreferences = (keys: string[]) => {
  return webapi.post<PreferResult>(`/v3/private/user/member/preferences`, {
    preference_keys: keys,
  });
};

export interface PreferResult {
  preferences: Record<string, any>;
}

export const setPreferences = (req: Record<string, any>) => {
  return webapi.post<void>(`/v3/private/user/member/pref-setting`, {
    upsert_keys: req,
  });
};


export interface OrderExceptionCheckParams {
  tokenName: string;
  side: Side;
  commissionPrice: string;
}

export const orderExceptionCheck = (params: OrderExceptionCheckParams) => {
  return webapi.get<void>(`/spot/api/marketTrading/v1/order/orderExceptionCheck`, params);
};

export interface OrderDetails {
  orderId: number;
  orderPrice: string;
  quantity: string;
  tradeAmount: string;
  feeAmount: string;
  tradeTime: number;
  orderNo: string;
  penaltyIncome: string;
  penaltyPayments: string;
}

export const getOrderDetails = (orderId: number) => {
  return webapi.get<OrderDetails[]>(`/spot/api/marketTrading/v2/order/orderDetails`, { orderId });
};


export interface CancelOrderCheck {
  allowOrderCancel: boolean
}
export const getCancelOrderCheck = ()=> {
  return webapi.get<CancelOrderCheck>(`/spot/api/marketTrading/v2/order/cancelOrderCheck`);
}